<app-header-content-help-text [Heading]="'Supplier Design Attributes'" [helpText]="'Configure Attributes for Supplier Design'"></app-header-content-help-text>
<app-parameter-table-molecule [fuctionality]="'shareofbusiness'"></app-parameter-table-molecule>
